import api from "../service";
import { store } from "store/configureStore";
import { hotToast, middlewareResponse } from "utils";

export const getOperationTypes = async (idOperationType: number) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `TipoOperacion/GetTiposOperacion?idTipoOperacion=${idOperationType}`
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};

export const addOperationType = async (form: FormData) => {
  if (!form.get("idUsuarioAct")) {
    form.append("idUsuarioAct", store.getState().user.idUsuario);
  }
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `TipoOperacion/InsertTipoOperacion`,
    form
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    hotToast("El tipo de operación se dío de alta correctamente", "SUCCESS");
    return true;
  }
  else if(!ok){
    const message= data?.message;
    if(message){
      message && hotToast(message, "ERROR");
    }
  }
  return null;
};

export const updateOperationType = async (
  id: number,
  form: FormData,
  disableOrEnable?: boolean
) => {
  if (!form.get("idUsuarioAct")) {
    form.append("idUsuarioAct", store.getState().user.idUsuario);
  }
  await api.setToken();
  let isValid: object | any | null = await api.requestPut(
    `TipoOperacion/UpdateTipoOperacion/${id}`,
    form
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    let messageView = disableOrEnable
      ? `El tipo operación se ${
          form.get("idEstatus") === "1" ? " activo" : "desactivo"
        } correctamente`
      : "El tipo de operación se guardó correctamente";
    hotToast(messageView, "SUCCESS");
    return true;
  }
  return null;
};

export const getOperationTypesByMarca = async (id: number) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(
    `TipoOperacion/marca/${id}`
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};

export const getOperacionFindForPerfilId = async (id: number | null) => {
  await api.setToken();
  let isValid: object | any | null = await api
    .requestGet(`TipoOperacion/operacionFindByPerfil/${id ? id : ""}`)
    .then(middlewareResponse);
  return isValid;
};

export const operacionFindByUsuario = async (id: number | null) => {
  await api.setToken();
  let isValid: object | any | null = await api
    .requestGet(`TipoOperacion/operacionFindByUsuario/${id ? id : ""}`)
    .then(middlewareResponse);
  return isValid;
};
